import type { Tile } from "../engine";
import { cardinalNeighbors } from "./roadBridgeNeighbors";
import { ROAD_CONNECT_E, ROAD_CONNECT_N, ROAD_CONNECT_S, ROAD_CONNECT_W } from "./roadConnectFlags";
import { isSeaShoreLandAt } from "./seaShoreLand";

const EDGE_LAYERS = [
  [ROAD_CONNECT_N, "north-edge"],
  [ROAD_CONNECT_E, "east-edge"],
  [ROAD_CONNECT_S, "south-edge"],
  [ROAD_CONNECT_W, "west-edge"],
] as const;

const INNER_CORNER_LAYERS = [
  { mask: ROAD_CONNECT_N | ROAD_CONNECT_E, layerName: "inner-corner-north-east" },
  { mask: ROAD_CONNECT_N | ROAD_CONNECT_W, layerName: "inner-corner-north-west" },
  { mask: ROAD_CONNECT_S | ROAD_CONNECT_E, layerName: "inner-corner-east-south" },
  { mask: ROAD_CONNECT_S | ROAD_CONNECT_W, layerName: "inner-corner-south-west" },
] as const;

export function landNeighborMask({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): number {
  const { north, east, south, west } = cardinalNeighbors({ tiles, width, x, y });
  let mask = 0;

  if (isSeaShoreLandAt({ tiles, width, x, y: y - 1, tile: north })) mask |= ROAD_CONNECT_N;
  if (isSeaShoreLandAt({ tiles, width, x: x + 1, y, tile: east })) mask |= ROAD_CONNECT_E;
  if (isSeaShoreLandAt({ tiles, width, x, y: y + 1, tile: south })) mask |= ROAD_CONNECT_S;
  if (isSeaShoreLandAt({ tiles, width, x: x - 1, y, tile: west })) mask |= ROAD_CONNECT_W;

  return mask;
}

export function resolveSeaShoreEdgeLayerNames({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): string[] {
  const mask = landNeighborMask({ tiles, width, x, y });
  return EDGE_LAYERS.flatMap(([flag, layerName]) => (mask & flag ? [layerName] : []));
}

export function resolveSeaShoreInnerCornerLayerNames({
  tiles,
  width,
  x,
  y,
}: {
  tiles: readonly Tile[];
  width: number;
  x: number;
  y: number;
}): string[] {
  const mask = landNeighborMask({ tiles, width, x, y });
  return INNER_CORNER_LAYERS.flatMap(({ mask: cornerMask, layerName }) =>
    (mask & cornerMask) === cornerMask ? [layerName] : [],
  );
}
